import { IApplicationState } from '../types/redux';

export const selectFormData = (state: IApplicationState) => state.formData;
